<template>
  <extensions-permission-guard :situation-id="situationId">
    <router-link :to="{ name: 'adminExhibitManagement' }">
      ← ギャラリー一覧に戻る
    </router-link>
    <v-container fluid>
      <div style="width: 800px" class="mx-auto">
        <h3 class="font-weight-regular mb-3 pa-4">1. 画像もしくは商品画像を設定してください</h3>
        <div align="center" v-if="!exhibit.imageDirectUrl && !exhibit.exhibitableId">
          <v-btn
            color="blue-grey"
            class="d-block mb-3 white--text"
            @click="imageUploaderSelecter = true"
          >
            画像を設定する
          </v-btn>
          <v-btn
            class="d-block mb-3 white--text"
            @click="selectProductDialog = true"
            color="blue-grey"
          >
            商品を設定する
          </v-btn>
        </div>
        <div class="p-postEditor__itemWrapper">
          <image-uploader-selecter
            :image-uploader-selecter="imageUploaderSelecter"
            :use-image-url="useImageUrl"
            :image-direct-url.sync="exhibit.imageDirectUrl"
            @close-image-uploader-selecter="imageUploaderSelecter = false"
            @select-picture="updateImage"
            @upload-download-image="uploadDownloadImage"
            @upload-picture="uploadPicture"
          />
        </div>
        <div class="p-imageCard__wrap" v-if="exhibit.exhibitableId || exhibit.imageDirectUrl">
          <v-card class="p-imageCard__center">
            <div class="p-imageCard__removeBtn" @click="deleteImage">
              <v-icon medium>mdi-close</v-icon>
            </div>
            <v-img
              class="preview_image"
              :src="imageSource"
              contain
              @:error="changeImageSource"
            />
          </v-card>
        </div>
        <v-text-field v-model="exhibit.imageSourceUrl" :rules="[urlValidation]" class="mt-5" style="width: 500px; margin: 0 auto;">
          <template v-slot:label>
            <InputLabel label-name="画像出典リンク" />
          </template>
        </v-text-field>
        <h3 class="font-weight-regular my-3 pa-4">2. 公開・非公開を設定してください</h3>
        <div align="center">
          <v-switch
            class="d-inline-block"
            v-model="exhibit.published"
            label="公開する"
          />
        </div>
        <h3 class="font-weight-regular my-3 pa-4">3. 関連する記事を設定してください</h3>
        <post-gallary
          :post-gallary="postGallary"
          :selectdPostIds='exhibitPostIds'
          @close-post-gallary="postGallary = false"
          @select-post="selectPost"
        />
        <v-card-text>
          <h4>関連記事</h4>
          <PostListSelectable
            :items="exhibit.exhibitRelatedPostsAttributes"
            @post-gallary="postGallary = true"
          />
        </v-card-text>

        <v-dialog v-model="selectProductDialog" width="800" @click:outside="selectProductDialog = false">
          <ProductSelecter
            @select-product="updateProduct"
          />
        </v-dialog>
        <ProductImageSelector
          :images-dialog="imagesDialog"
          :product-images="productImages"
          @update-product-gallary="updateProductGallary"
          @close-gallary-selecter="imagesDialog = false"
          @product-image-selector-dialog="imagesDialogValue"
        />
        <v-btn
          class="scrollSaveButton"
          justifiy-content-center
          align="center"
          @click="exhibitAction"
          color="primary"
        >
          保存
        </v-btn>
      </div>
    </v-container>
  </extensions-permission-guard>
</template>

<script>
import PostGallary from '@/components/commons/PostGallary'
import ImageUploaderSelecter from '@/components/postEditor/parts/ImageUploaderSelecter'
import ProductImageSelector from '@/components/commons/products/ProductImageSelector'
import ProductSelecter from '@/components/postEditor/parts/ProductSelecter'
import PostListSelectable from '@/components/commons/PostListSelectable'
import ExtensionsPermissionGuard from '@/components/commons/ExtensionsPermissionGuard'
import { EXHIBITS_SITUATION_ID } from '@/mixins/site_permission_utils'
import imageUtilsMixin from '@/mixins/image_utils'
import InputLabel from '@/components/commons/formParts/inputLabel'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  components: {
    ImageUploaderSelecter,
    PostGallary,
    ProductImageSelector,
    ProductSelecter,
    ExtensionsPermissionGuard,
    PostListSelectable,
    InputLabel
  },
  mixins: [imageUtilsMixin, formValidationUtils],
  props: {
    exhibit: {
      type: Object,
      required: true
    }
  },
  data: () => {
    return {
      situationId: EXHIBITS_SITUATION_ID,
      imageItemOverlay: false,
      imageUploaderSelecter: false,
      selectProductDialog: false,
      useImageUrl: true,
      imagesDialog: false,
      productImages: [],
      postGallary: false,
      failedFlg: false
    }
  },
  computed: {
    imageSource: function () {
      if (this.exhibit.imageDirectUrl) {
        return this.exhibit.imageDirectUrl
      } else {
        return this.failedFlg ? this.oldImageSource() : this.preSource()
      }
    },
    exhibitPostIds: function () {
      let ids = []
      this.exhibit.exhibitRelatedPostsAttributes.forEach((post) => {
        if (post.destroy == false) {
          ids.push(post.post.id)
        }
      })
      return ids
    }
  },
  methods: {
    exhibitAction () {
      if (!this.isExhibitExisted()) {
        this.displayErrorMessage('画像を設定してください')
        return false
      }

      this.$emit('exhibit-action')
    },
    preSource () {
      if (this.exhibit.imagableUrl) {
        return this.getFilePath(this.exhibit.imagableUrl)
      } else {
        return `http://placehold.jp/eeeeee/cccccc/200x200.png?text=No%20Image`
      }
    },
    changeImageSource () {
      this.failedFlg = true
    },
    oldImageSource () {
      if (this.exhibt.imagableUrl) {
        this.updateEditingItemable(
          this.exhibt.imagableUrl.replace(/fitMiddle/, 'middle'),
          'imagableUrl'
        )
        return this.exhibt.imagableUrl
      }
    },
    updateImage (picture) {
      this.exhibit.exhibitableId = picture.id
      this.exhibit.exhibitableType = 'Picture'
      this.exhibit.imagableUrl = picture.file.fitMiddle.url
      this.imageUploaderSelecter = false
    },
    uploadDownloadImage (downloadImage) {
      this.exhibit.exhibitableId = downloadImage.id
      this.exhibit.exhibitableType = 'DownloadImage'
      this.exhibit.imagableUrl = downloadImage.file.fitMiddle.url
      this.imageUploaderSelecter = false
    },
    uploadPicture (picture) {
      this.exhibit.exhibitableId = picture.id
      this.exhibit.exhibitableType = 'Picture'
      this.exhibit.imagableUrl = picture.file.fitMiddle.url
      this.imageUploaderSelecter = false
    },
    updateProductGallary (imageFile) {
      this.exhibit.exhibitableId = imageFile.id
      this.exhibit.exhibitableType = 'ProductImage'
      this.exhibit.imagableUrl = imageFile.file.url
      this.imageUploaderSelecter = false
    },
    deleteImage () {
      this.exhibit.imageDirectUrl = null
      this.exhibit.exhibitableId = null
      this.exhibit.exhibitableType = null
      this.exhibit.imagableUrl = null
    },
    selectPost (post) {
      const postIdAndDestroys = this.exhibit.exhibitRelatedPostsAttributes.map(
        (item) => {
          return { id: item.postId, destroy: item.destroy }
        }
      )
      const checkOldPost = postIdAndDestroys.find(
        (item) => item.id === post.id && item.destroy === false
      )
      if (checkOldPost) {
        const payload = {
          status: 500,
          message: 'この記事はすでに選択されています。'
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      } else {
        this.changeDestroyOrAddPost(post)
      }
    },
    updateProduct (product) {
      this.imagesDialog = true
      this.selectProductDialog = false
      this.productImages = product.productImages
    },
    imagesDialogValue (value) {
      this.imagesDialog = value
    },
    changeDestroyOrAddPost (post) {
      const postIds = this.exhibit.exhibitRelatedPostsAttributes.map(
        (item) => item.postId
      )
      if (postIds.includes(post.id)) {
        this.exhibit.exhibitRelatedPostsAttributes.find(
          (item) => item.postId === post.id
        ).destroy = false
      } else {
        this.exhibit.exhibitRelatedPostsAttributes.push({
          postId: post.id,
          post: post,
          destroy: false
        })
      }
    },
    isExhibitExisted () {
      return !!this.exhibit.imageDirectUrl || !!this.exhibit.exhibitableId
    },
    displayErrorMessage (errorMessage) {
      const payload = {
        status: 400,
        message: errorMessage
      }
      this.$store.dispatch('SystemMessageStore/createMessage', payload)
    }
  }
}
</script>

<style scoped lang="sass">
.borderRightDotted
  border-right: dotted
.preview_image
  max-height: 300px
  min-height: 300px
  max-width: 300px
  margin: 0 auto
.p-imageCard
  &__center
    max-height: 300px
    min-height: 300px
    max-width: 300px
  &__block
    counter-reset: priority
  &__wrap
    min-height: 300px
    cursor: grab
  .ghost
    opacity: 0
  &__priority
    display: block
    position: absolute
    top: 0
    left: 0
    width: 25px
    height: 25px
    text-align: center
    background-color: #ddd
    font-weight: bold
  &__wrap:hover &__removeBtn
    display: block
    cursor: pointer
  &__removeBtn
    display: none
    position: absolute
    color: #000
    background-color: #fff
    right: 0
    top: 0
    z-index: 1
    height: 26px
    width: 26px
    border-top-left-radius: 0 !important
    border-top-right-radius: 0 !important
  &__center
    margin: 0 auto
.scrollSaveButton
  position: fixed
  bottom: 40px
  right: 150px
</style>
